import { NoddiTextArea } from '@ui-components/Inputs/NoddiTextArea';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<React.ComponentProps<typeof NoddiTextArea>, 'defaultValue'>;

export const TanstackFormTextArea = ({ rows = 3, ...rest }: Props) => {
  const field = useFieldContext<string>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiTextArea
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        value={field.state.value ?? ''}
        onBlur={field.handleBlur}
        onChange={(event) => {
          field.handleChange(event.target.value);
        }}
        rows={rows}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
